import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { transformFormData } from "../utils";
import { postIflowFormData } from "~/store/ducks/processes/actionTypes";

import InputSearch from "~/pages/Easypay/components/InputSearch";
import oauth from "~/utils/oauth";

const CreateInputSearch = ({ field, countryList, defaultSelected }) => {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [required, setRequired] = useState(false);

  useEffect(() => {
    if (field) {
      if (field.obligatory) {
        if (field.obligatory === "true") setRequired(true);
        else setRequired(false);
      }
      if (field.option) {
        if (!Array.isArray(field.option)) {
          field.option = [field.option];
        }
        const optionList = field.option.map((option) => ({
          label: option.text,
          value: option.value,
          selected: option.selected === "yes" || defaultSelected === option.value ? true : false,
        }));

        if (optionList) {
          setList(optionList);
        }
      }
    }
  }, [field]);

  const handleSelectChange = (value) => {
    console.log(field)
    if (field.onchange_submit !== "") {
      if (field.onchange_submit.includes("document.dados.op.value='")) {
        const array = field.onchange_submit.split("document.dados.op.value='");
        if (array) {
          const array2 = array[1].split("'");
          if (array2) {
            document.dados.op.value = array2[0];
          }
        }
      }
      if (field.onchange_submit.includes("document.dados.submit()")) {
        const formdata = transformFormData(
          new FormData(document.getElementsByName("dados")[0])
        );
        const url =
          "/Form/form.jsp?" +
          "flowid=" +
          formdata.get("flowid") +
          "&pid=" +
          formdata.get("pid") +
          "&subpid=" +
          formdata.get("subpid") +
          "&Authorization=" +
          oauth.getAccessToken();
        dispatch(postIflowFormData(formdata, url));
      }
    }
  };

  return (
    <Form.Group controlId={`formSelect-${field.variable}`}>
      <InputSearch
        name={field.variable}
        list={list}
        required={required}
        handleSubmit={(value) => handleSelectChange(value)}
        text={field.text.split("::")[0] !== "country" ? field.text.split("::")[0] :""}
        placeholder={
          field.text.split("::").length === 3 ? field.text.split("::")[2] : ""
        }
       countryList={countryList}
      />
    </Form.Group>
  );
};
export default CreateInputSearch;
